import { Component, Input, OnInit } from '@angular/core';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { CNContactRXSerie } from 'src/app/models/cncontactrxserie';

@Component({
  selector: 'app-contact-row-content',
  templateUrl: './contact-row-content.component.html',
  styleUrls: ['./contact-row-content.component.scss']
})
export class ContactRowContentComponent implements OnInit {

  public contact: CNConsultation;
  public type: CNConsultationType;
  constructor() { }

  ngOnInit(): void {
  }

  @Input() set item(theItem) {
    this.contact = theItem;
    if (this.contact) {
      if (this.contact.getProperty('StVaast_Type')) {
        this.type = this.contact.getProperty('StVaast_Type');
      } else {
        this.type = CNConsultationType.Simple;
      }
    }
  }

  get content() {
    switch (this.type) {
      case CNConsultationType.Simple:
        return this.contact.value;
      case CNConsultationType.Logo:
        return this.contact.value;
      case CNConsultationType.Kine:
        return this.contact.value;
      case CNConsultationType.Cardio:
        return this.contact.cardio.complaints.reason;
      case CNConsultationType.RX:
        return 'RX';
      default:
        return this.contact.value;
    }
  }
}
